import StudentDebts from './student-debts'

export default StudentDebts
